import "slick-carousel"

export default () => {

	let sliderSmiles = $('.smiles-slides');

	if (sliderSmiles.length >= 1) {
		sliderSmiles.slick({
			infinite: true,
			arrows: true,
			dots: true,
			rows: 0,
			slidesToShow: 1,
			slidesToScroll: 3,
			autoplay: true,
			pauseOnHover: true,
			pauseOnFocus: false,
			autoplaySpeed: 3500,
			speed: 800,
			cssEase: 'ease-in-out',
			centerMode: true,
			centerPadding: '315px',
			variableWidth: true,
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						arrows: true,
						centerMode: true,
						centerPadding: '200px',
						slidesToShow: 1,
					},
				},
				{
					breakpoint: 992,
					settings: {
						arrows: true,
						centerMode: true,
						centerPadding: '150px',
						slidesToShow: 1,
					},
				},
				{
					breakpoint: 768,
					settings: {
						arrows: true,
						dots: true,
						centerMode: true,
						centerPadding: '50px',
						slidesToShow: 1,
					},
				},
			],
		});
	}
}



// WEBPACK FOOTER //
// ./scripts/modules/_smiles-slider.js